import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import NotificationContainer from 'react-notifications/lib/NotificationContainer';
import 'react-notifications/lib/notifications.css';

// this enable all console.log stmts to return an empty function
// console.log = function() {};

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      {/* <React.Suspense fallback={<CircularProgress size="2rem" />}> */}
      <App />
      <NotificationContainer />
      {/* </React.Suspense> */}
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
